import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */
const SvgOk = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1.5em"
    height="1.5em"
    fill="none"
    viewBox="0 0 24 24"
    ref={svgRef}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.04 16.232a9.575 9.575 0 002.908-1.16 1.38 1.38 0 00.404-1.96c-.433-.623-1.296-.811-1.967-.43a6.564 6.564 0 01-6.738 0c-.684-.415-1.587-.217-2.02.44l-.001.004a1.378 1.378 0 00.458 1.944l.002.002c.892.54 1.875.933 2.905 1.157l-2.8 2.695a1.36 1.36 0 00-.022 1.974l.024.023a1.46 1.46 0 001.03.412c.375 0 .75-.136 1.03-.412l2.763-2.648 2.75 2.65c.582.54 1.51.526 2.073-.035a1.375 1.375 0 000-1.96l-2.8-2.696zm-2.024-3.93c2.763-.003 5-2.157 5.005-4.817 0-2.656-2.246-4.818-5.005-4.818s-5.005 2.162-5.005 4.82c.004 2.66 2.243 4.814 5.005 4.816zm0-6.811c1.144.001 2.07.894 2.071 1.995 0 1.101-.927 1.994-2.071 1.995-1.143-.001-2.07-.893-2.072-1.994.001-1.102.929-1.995 2.072-1.997z"
      clipRule="evenodd"
    />
  </svg>
));
SvgOk.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgOk;
